"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const driversService = {
  getDrivers: function () {
    return api.get("/Drivers", WithToken.headersToken({}, configuration.cookieName));
  },
  createDriver: function (options) {
    return api.post(`/Drivers`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateDriver: function (options) {
    return api.put(`/Drivers/${options.id}`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteDriver: function (options) {
    return api.delete(`/Drivers`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createDriverUnit: function (options) {
    return api.post(`/DriverUnits`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteDriverUnit: function (options) {
    return api.delete(`/DriverUnits`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  downloadDrives: function () {
    return api.get(`/Companies/Drivers/Download`, WithToken.headersToken({ responseType: "blob" }, configuration.cookieName));
  },
};

export default driversService;
